import React from 'react';
import { Icon } from '@vectord/components';
import { useSelector } from 'react-redux';
import classNames from 'classnames';

import { blacklistedMenteeDetailSelector } from 'features/communicationManagement';
import PersonalisedMenteeEmailersConfirmDetailInfo from '../PersonalisedMenteeEmailersConfirmDetailInfo';
import PersonalisedMenteeEmailersManageConfirmButton from '../PersonalisedMenteeEmailersManageConfirmButton';
import SectionHeading from 'components/SectionHeading';
import styles from './PersonalisedMenteeEmailersManageConfirmModal.module.scss';

export default function PersonalisedMenteeEmailersManageConfirmModal() {
  const snoozeLearnerDetail = useSelector(blacklistedMenteeDetailSelector);

  return (
    <>
      <SectionHeading
        title={
          <div className={styles.header}>
            <Icon
              name="warning"
              className="m-r-xxs danger"
            />
            Are you sure you want to snooze the following:
          </div>
        }
      />
      <div className={classNames(styles.footerContainer, 'm-b-xxs')}>
        <PersonalisedMenteeEmailersConfirmDetailInfo
          label="Learner Email:"
          detail={snoozeLearnerDetail.user_email}
        />
        <PersonalisedMenteeEmailersConfirmDetailInfo
          label="Batch Name:"
          detail={snoozeLearnerDetail.super_batch_name}
        />
      </div>
      <div className={styles.footer}>
        <PersonalisedMenteeEmailersManageConfirmButton />
      </div>
    </>
  );
}
